import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from '../components/Header';
import { Main } from '../containers';

const RouterNavigate = () => (
  <BrowserRouter>
    <Header />
    <Main />
  </BrowserRouter>
);

export default RouterNavigate;
